export function ProgressMeter({ filled, total }: { filled: number; total: number }) {
  const pct = total === 0 ? 0 : Math.round((filled / total) * 100);

  return (
    <div className="flex items-center gap-2" role="status" aria-live="polite">
      <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-paper-dim">
        <div className="h-full rounded-full bg-sage-strong transition-all" style={{ width: `${pct}%` }} />
      </div>
      <span className="whitespace-nowrap text-xs font-medium text-ink-soft">
        {filled}/{total}
      </span>
    </div>
  );
}
